<script lang="ts" setup>
import { useArticlesPage } from '@/domains/articles/composables/useArticlesPage'

const { t, locale } = useI18n()
const { elements } = await useArticlesPage()
const title = t('articles.title')

useHead({
  title: t('pageTitles.articles.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.articles.meta'),
    },
  ],
  link: [
    {
      hid: 'favicon',
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico',
    },
    {
      rel: 'canonical',
      href: t(`pageTitles.articles.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.articles.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.articles.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.articles.canonical.pl'),
    },
  ],
})
</script>

<template>
  <section class="articles">
    <header class="articles__header">
      <h1 class="articles__header_title">
        {{ title }}
      </h1>
    </header>
    <div class="articles__list">
      <ArticleCard
        v-for="element in elements"
        :key="element.id"
        :title="element.title"
        :description="element.description"
        :image="element.image"
        :author="element.author.name"
        :date="element.date"
        :url="element.url"
      />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.articles {
  padding-bottom: 4.8rem;
  background-color: $gray-100;

  @include atM {
    padding-bottom: 8.4rem;
  }

  &__header {
    padding: 8.8rem 2.8rem 4rem 2.8rem;
    background-color: $white;
    border-bottom-right-radius: 2.4rem;
    border-bottom-left-radius: 2.4rem;

    @include atM {
      padding: 10rem 2.8rem 3rem 2.8rem;
    }

    &_title {
      font-weight: 500;
      font-size: 4.8rem;
      line-height: 5.6rem;

      @include atM {
        max-width: 129rem;
        margin: 0 auto;
        padding-right: 2.4rem;
        padding-left: 2.4rem;
        font-size: 6.4rem;
        line-height: 8.8rem;
      }

      @include atXL {
        max-width: 136.8rem;
      }
    }
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
    max-width: 129rem;
    margin: 2.4rem auto 4.8rem auto;
    padding-right: 2.4rem;
    padding-left: 2.4rem;

    @include atXS {
      flex-direction: row;
      flex-wrap: wrap;

      .card {
        width: calc(50% - 1.2rem);
      }
    }

    @include atS {
      .card {
        width: calc(33% - 1.4rem);
      }
    }

    @include atM {
      gap: 4.4rem;
      margin: 3rem auto 8.4rem auto;

      .card {
        width: calc(33% - 2.6rem);
      }
    }

    @include atXL {
      max-width: 136.8rem;
    }
  }
}
</style>
